"use client";

import { createContext, useContext, type ReactNode } from "react";
import type { StudentCoBrandPayload } from "@/lib/partnerBranding";

type PartnerBrandingContextValue = {
  branding: StudentCoBrandPayload | null;
  /** Resolved accent for buttons (hex or default amber). */
  primaryAccent: string;
  secondaryAccent: string;
};

const PartnerBrandingContext = createContext<PartnerBrandingContextValue | null>(null);

const DEFAULT_PRIMARY = "#f59e0b";
const DEFAULT_SECONDARY = "#6366f1";

export function PartnerBrandingProvider({
  children,
  branding,
}: {
  children: ReactNode;
  branding: StudentCoBrandPayload | null;
}) {
  const active = branding?.active === true;
  const primaryAccent = active && branding?.primary_color ? branding.primary_color : DEFAULT_PRIMARY;
  const secondaryAccent =
    active && branding?.secondary_color ? branding.secondary_color : DEFAULT_SECONDARY;

  return (
    <PartnerBrandingContext.Provider
      value={{ branding: active ? branding : null, primaryAccent, secondaryAccent }}
    >
      {children}
    </PartnerBrandingContext.Provider>
  );
}

export function usePartnerBrandingOptional(): PartnerBrandingContextValue {
  const v = useContext(PartnerBrandingContext);
  if (!v) {
    return {
      branding: null,
      primaryAccent: DEFAULT_PRIMARY,
      secondaryAccent: DEFAULT_SECONDARY,
    };
  }
  return v;
}
